import { useQuery } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

export type WithdrawPreventionResponse = {
  is_prevent_from_withdraw: boolean;
} | null;

const fetchWithdrawPrevention = async (
  user_id: string,
): Promise<WithdrawPreventionResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.get(
    API_ROUTES.USER_WITHDRAW_PREVENTION.replace("{user_id}", user_id),
  );

  return response?.data ?? null;
};

export const useGetWithdrawPrevention = (
  user_id?: string | null,
  enabled: boolean = true,
) =>
  useQuery<WithdrawPreventionResponse, Error>({
    queryKey: ["withdrawPrevention", user_id],
    queryFn: () => fetchWithdrawPrevention(user_id as string),
    enabled: Boolean(user_id) && enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
